import { useKestrel } from 'features/kestrelViewer'
import React from 'react'
import styled from 'styled-components'
import { KVInspectionArea } from 'types'

const StatusContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  z-index: 100;
`

const DropdownTrigger = styled.div`
  cursor: pointer;
  width: 100%;
  min-height: 32px; // Match label input minHeight exactly
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 4px;
  position: relative;
  box-sizing: border-box;
  padding: 4px;
  background-color: rgba(255, 255, 255, 0.1);
  color: white;
  display: flex;
  align-items: center;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: rgba(255, 255, 255, 0.2);
  }

  &:active {
    background-color: rgba(255, 255, 255, 0.3);
  }
`

const DropdownMenu = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.9);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  z-index: 1000;
`

const DropdownOption = styled.div<{ $isSelected: boolean }>`
  width: 100%;
  padding: 8px 12px;
  color: white;
  cursor: pointer;
  transition: background-color 0.2s ease;

  background-color: ${({ $isSelected }) =>
    $isSelected ? 'rgba(255, 255, 255, 0.2)' : 'transparent'};

  &:hover {
    background-color: ${({ $isSelected }) =>
      $isSelected ? 'rgba(255, 255, 255, 0.3)' : 'rgba(255, 255, 255, 0.1)'};
  }

  &:first-child {
    border-radius: 4px 4px 0 0;
  }

  &:last-child {
    border-radius: 0 0 4px 4px;
  }
`

export const InspectionAreaStatusDropdown: React.FC<{
  selectedInspectionArea: KVInspectionArea
}> = ({ selectedInspectionArea }) => {
  const { updateInspectionArea } = useKestrel()

  const inspectionAreaStatus = [
    'Not Started',
    'In Progress',
    'Completed',
    'Flagged',
  ]

  const [isOpen, setIsOpen] = React.useState(false)

  const setStatus = (s: string) => {
    // Note: For inspection areas, we might want to control fillVisible instead of interiorVisible
    // Adjust this logic based on your requirements
    const fillVisible = s !== 'In Progress'
    updateInspectionArea(
      selectedInspectionArea,
      ['inspectionAreaStatus', 'inspectionAreaFillVisible'],
      (a) => {
        a.status = s
        a.fillVisible = fillVisible
        return a
      },
      [s, fillVisible]
    )
  }

  return (
    <StatusContainer>
      <DropdownTrigger onClick={() => setIsOpen(!isOpen)}>
        {selectedInspectionArea.status}
        {isOpen && (
          <DropdownMenu>
            {inspectionAreaStatus.map((t) => (
              <DropdownOption
                key={t}
                $isSelected={selectedInspectionArea.status === t}
                onClick={() => {
                  setStatus(t)
                  setIsOpen(false)
                }}>
                {t}
              </DropdownOption>
            ))}
          </DropdownMenu>
        )}
      </DropdownTrigger>
    </StatusContainer>
  )
}
